import Script from 'next/script';
import { useEffect, useState } from 'react';

import { useAuth } from 'components/context/AuthContext';

import { IS_DEVELOPMENT } from 'utils/envs';

import { UserType } from 'graphql/types';

export default function SupportChatBot() {
  const [isChatLoaded, setIsChatLoaded] = useState(false);

  const { isAuthorized } = useAuth();

  useEffect(() => {
    // если авторизован и загрузился скрипт
    if (isAuthorized && isChatLoaded) {
      try {
        const user: UserType = ZnanieSDK.getUser();

        usedeskMessenger.userIdentify({
          name: `${user?.firstName || ''} ${user?.lastName || ''}`,
          email: user?.email || '',
        });
      } catch (err) {
        console.log(err);
      }
    }
  }, [isAuthorized, isChatLoaded]);

  return !IS_DEVELOPMENT ? (
    <Script
      async
      src="https://lib.usedesk.ru/secure.usedesk.ru/widget_162696_35465.js"
      strategy="lazyOnload"
      onLoad={() => setIsChatLoaded(true)}
    />
  ) : null;
}
